import './StatusBadge.css';

interface StatusBadgeProps {
    status: string;
    className?: string;
}

export default function StatusBadge({ status, className = '' }: StatusBadgeProps) {
    const getStatusColor = (status: string) => {
        const s = status.toUpperCase();
        if (['COMPLETED', 'SUCCESS', 'ACTIVE', 'CONFIRMED'].includes(s)) return 'green';
        if (['PENDING', 'PROCESSING', 'WAITING'].includes(s)) return 'yellow';
        if (['FAILED', 'REJECTED', 'ERROR', 'INACTIVE'].includes(s)) return 'red';
        if (['PAYMENT_DETECTED', 'DETECTED'].includes(s)) return 'blue';
        if (['REFUNDED'].includes(s)) return 'orange';
        return 'gray';
    };

    const color = getStatusColor(status);

    return (
        <span className={`status-badge status-${color} ${className}`}>
            {status.replace(/_/g, ' ')}
        </span>
    );
}
